import React, { useState } from "react";
import InternalMessageCamapign from "./InternalMessageCamapign";
import ExternalMessageCamapaign from "./ExternalMessageCamapaign";
import "../../ticket/ticketListInfo/Messages.scss";

interface NOTES {
  notesData: any;
  fetchingNotes: any;
  refetchLeadTrail: any;
}

const MessagesTab: React.FC<NOTES> = ({ notesData, fetchingNotes, refetchLeadTrail }) => {
  const [radioValue, setRadioValue] = useState("Internal Notes");
  const [showCompose, setShowCompose] = useState(false);

  const notesButton = ["Internal Notes", "External Notes"];

  const buttonChangeHandler = (value: string) => {
    setRadioValue(value);
    setShowCompose(false);
  };

  return (
    <div className="messages-container">
      <div className="messages-card card">
        <div className="messages-header">
          <div className="tabs-container">
            {notesButton.map((el: string) => (
              <button
                key={el}
                className={`tab-button ${radioValue === el ? "active" : ""}`}
                onClick={() => buttonChangeHandler(el)}
              >
                {el}
              </button>
            ))}
          </div>

          <button
            className="add-note-btn"
            onClick={() => setShowCompose(!showCompose)}
          >
            <span>+</span>
            <span>Add Note</span>
          </button>
        </div>

        <div className="messages-body">
          {radioValue === "External Notes" ? (
            <ExternalMessageCamapaign
              customerNotes={notesData?.customer_notes}
              fetchingNotes={fetchingNotes}
              showCompose={showCompose}
              setShowCompose={setShowCompose}
            />
          ) : (
            <InternalMessageCamapign
              internalNotes={notesData?.lead_internal_notes}
              notesData={notesData}
              fetchingNotes={fetchingNotes}
              refetchLeadTrail={refetchLeadTrail}
              showCompose={showCompose}
              setShowCompose={setShowCompose}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MessagesTab;